import React from "react";
import { ethers } from "ethers";
import { parseEther } from "ethers/lib/utils";
import collectionABI from "../ABI/collectionABI.json";
import batchABI from "../ABI/batchABI.json";
import { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";




export default function FormTransfer(props) {
  const [collection, setCollection] = useState(props.props);
  const [batchAddress, setBatchAddress] = useState("0xbD82DE7c06f5c2088E05BC93F5998491b11bf81A");
  const [inputList, setInputList] = useState([{ id: "1", address: "", tokenIds: "" }]);
  
  // handle input change
  const handleAddressChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  // handle input change
  const handleTokensChange = (e, index, id) => {
    const { value } = e.target;
    const list = [...inputList];

    const toNumber = value.split(',').map(function (item) {
      return parseInt(item, 10);
    });

    list[id - 1].tokenIds = toNumber;

    setInputList(list);
  };

  // handle click event of the Remove button
  const handleRemoveClick = index => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, { id: `${(inputList.length + 1)}`, address: "", tokenIds: "" }]);
  };

  const approve = async () => {
    const _provider = new ethers.providers.Web3Provider(window.ethereum);
    const _collection = new ethers.Contract(
      props.props,
      collectionABI,
      _provider.getSigner(0)
    );

    setCollection(_collection.address);

    console.log(`setApprovalForAll(${batchAddress}, true) to be called on Collecton: ${collection}`);
    const log = await _collection.setApprovalForAll(batchAddress, true);
    return log;
  }

  const transfer = async () => {
    const _provider = new ethers.providers.Web3Provider(window.ethereum);

    const signer = _provider.getSigner()

    const _batch = new ethers.Contract(
      batchAddress,
      batchABI,
      signer
    );

    setBatchAddress(_batch.address);
    setCollection(props.props);

    const addressArray = [];
    const tokensArray = [];
      //eslint-disable-next-line
    for (const [k, v] of Object.entries(inputList)) {
      addressArray.push(v.address);
      tokensArray.push(v.tokenIds);
    }
    
    console.log(`
          TX args:\n
              Collection: ${props.props},
              \n Recipients: ${addressArray},
              \n TokenIds: ${tokensArray}.
    `);
    for (let i = 0; i< addressArray.length; i++) {
      console.log(`Transferring tokenIds [${tokensArray[i]}] to recipients account: ${addressArray[i]},`);;
    }

    let tx = await _batch.spreadERC721(props.props, addressArray, tokensArray, { value: parseEther("0.005") });
    console.log(tx);
    if (tx.confirmation <= 1) {console.log(`success: ${tx.transactionhash}`)}
  }




return (
  <>
    <Row className="flex min-h-screen flex-col items-center justify-center py-2">
      <Col className="mb-3" style={{ text: "center" }}>
        <Form
          className="mb-3"
          style={{ marginleft: "20px" }}
        >
          <Form.Label className="sm-2 mb-3">
            Input Receiver Addresses & TokenIds
          </Form.Label>

          {inputList.map((x, i) => {
            return (
              <React.Fragment key={x.id}>
                <Form.Group
                  as={Col}
                  className="mb-3"
                  controlId={x.id}
                >

                  <div
                    className="d-flex"
                  >
                    <Form.Control
                      marginleft="10px"
                      name="address"
                      onChange={e => handleAddressChange(e, i)}
                      type="text"
                      defaultValue={x.address}
                      placeholder={`Address #${i + 1}`}
                    />
                    <Form.Control
                      marginright="10px"
                      name="tokenIds"
                      onChange={e => handleTokensChange(e, i, x.id)}
                      type="text"
                      defaultValue={x.tokenIds}
                      placeholder="TokenIds 1,3,41..."
                    />
                    <div className="d-flex">
                      {inputList.length !== 1 && <Button
                        type="button"
                        onClick={() => handleRemoveClick(i)}>-</Button>}
                      {inputList.length - 1 === i && <Button type="button" onClick={handleAddClick}>+</Button>}
                    </div>
                  </div>
                </Form.Group>
              </React.Fragment>

            );
          })}
          <Button
            id="buttons"
            type="button"
            onClick={
              () => {
                approve()
              }}
            variant="warning">
            Approve
          </Button>
          <Button
            id="buttons"
            type="button"
            onClick={
              () => {
                transfer()
              }}
            variant="warning"
          >
            Send
          </Button>
        </Form>
      </Col>
    </Row>
  </>
);
}
/// line 156 add:
/// <div style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div>